module.exports = __webpack_public_path__ + "static/media/mentor_ship_plan.9cf87b04.png";